import React from 'react';
import { Text, FormLabel, Flex, Icon } from '@chakra-ui/react';
import { IconType } from 'react-icons';

type InputLabelProps = {
  icon?: IconType;
  label: string;
  subLabel?: string;
  required?: boolean;
};

const InputLabel = ({
  icon,
  label,
  subLabel,
  required = false,
}: InputLabelProps) => {
  return (
    <FormLabel>
      <Flex alignItems="center">
        {icon && <Icon as={icon} mr="1.5px" />}
        <Text fontWeight="semibold">{label}</Text>
        {required && (
          <Text ml="4px" color="#D84E46">
            *
          </Text>
        )}
        {subLabel && (
          <Text ml="4px" color="#9E9E9E" fontSize="12px" alignSelf="end">
            {subLabel}
          </Text>
        )}
      </Flex>
    </FormLabel>
  );
};

export default InputLabel;
